"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.media = void 0;
/**
 * FILES
 */
// Provide a `key` if the path is constant
// /{authorAddress}/{storyId}
const INTRO_VIDEO_FILE = 'intro.mp4';
// /{authorAddress}/{storyId}
const INTRO_POSTER_FILE = 'poster.jpg';
const files = {
    INTRO_VIDEO_FILE,
    INTRO_POSTER_FILE,
};
exports.media = {
    files,
};
//# sourceMappingURL=index.js.map